<!--
 * @Description: 添加项目
 * @LastEditors: wjx
 * @Date: 2020-11-25 14:43:54
-->
<template>
  <div>
    <p style="margin-bottom:20px">添加后，用户将直接被邀请入驻此项目</p>
    <el-form>
      <el-form-item label="项目列表：">
        <dic-select
          @dic-select-obj="selectProject"
          :fuzzyDef="selectAjax"
          :prop="selectProp"
          :ajaxQueryObj="ajaxQueryObj"
          ajaxQuery="projectName"
          placeholder="请选择项目"
        ></dic-select>
      </el-form-item>
      <el-form-item>
        <el-tag
          style="margin-right:24px"
          closable
          v-for="(item, index) in projects"
          :key="index"
          @close="handleClose(item)"
        >
          {{ item.projectName }}
        </el-tag>
      </el-form-item>
    </el-form>
    <div style="text-align:center;margin-top:60px">
      <el-button type="info" @click="cancel" style="margin-right:80px">
        取消
      </el-button>
      <el-button
        type="primary"
        @click="confirm"
        :disabled="!projects.length"
        :loading="loading"
      >
        确认添加
      </el-button>
    </div>
  </div>
</template>

<script>
import dicSelect from '@/components/Common/dicSelect';
import { agentManager } from '@/api/ajax';
export default {
  name: 'AddProject',
  props: {
    userId: Number
  },
  data() {
    return {
      selectAjax: agentManager.projectInfoSuitable,
      selectProp: {
        label: 'projectName',
        code: 'id'
      },
      projects: [],
      ajaxQueryObj: {},
      loading: false
    };
  },
  components: {
    dicSelect
  },
  watch: {},
  computed: {},
  methods: {
    selectProject(v) {
      let projectIds = this.projects.map(item => item.id);
      if (!projectIds.includes(v.id) && v.id) {
        this.projects.push(v);
      }
    },
    handleClose(project) {
      let closeIndex = this.projects.indexOf(project);
      this.projects.splice(closeIndex, 1);
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    async confirm() {
      this.loading = true;
      await agentManager.projectsJoin({
        userId: this.userId,
        projectIds: this.projects.map(item => item.id)
      });
      this.$emit('confirm');
    }
  },
  created() {
    this.ajaxQueryObj = {
      userId: this.userId
    };
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
